enum ActionTypes {
  GET_JOB = 'careers/Job/GET_JOB',
  GET_JOB_SUCCESS = 'careers/Job/GET_JOB_SUCCESS',
  GET_JOB_FAILURE = 'careers/Job/GET_JOB_FAILURE',
  LIST_JOBS = 'careers/Job/LIST_JOBS',
  LIST_JOBS_SUCCESS = 'careers/Job/LIST_JOBS_SUCCESS',
  LIST_JOBS_FAILURE = 'careers/Job/LIST_JOBS_FAILURE',
}
export default ActionTypes;